import styled from 'styled-components'

/*
 * A regua de horas acompanha a faixa dos profissionais: fundo laranja da
 * marca, horario em branco. Antes era fundo claro com o numero em laranja, e
 * a coluna se confundia com a grade em vez de emoldurar ela.
 */
export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  width: 71px;
  height: 100%;
  color: #fff;
  background: ${(props) => props.theme.colors.scale[500]};
  position: sticky;
  left: 0;
  z-index: 5;
`

export const ScheduleHoursLine = styled.div`
  width: 100%;
  min-height: ${(props) => `calc(20px * ${props.totalGaps})`};
  color: #fff;
  font-weight: 600;
  padding: 5px 10px;
  /* as divisorias agora sao claras sobre o laranja, nao laranjas sobre o claro */
  border-bottom: 1px solid transparent;

  &:last-child {
    border-bottom: 1px solid ${(props) => props.theme.colors.scale[400]};
  }
`
